module.exports = __webpack_public_path__ + "img/invite.74fc895b.png";